module.exports = __webpack_public_path__ + "static/media/34.dd1009cb.png";